// Inputs
import Input_EditDefaultLabel from '$lib/components/common/inputs/textInputs/editableLabels/EditDefaultLabel.svelte';
import Input_EditLargeLabel from '$lib/components/common/inputs/textInputs/editableLabels/EditLargeLabel.svelte';
import Input_IconLeft from '$lib/components/common/inputs/textInputs/DebouncedTextInputWithLeftIcon.svelte';
import Input_IconLeftInteractive from '$lib/components/common/inputs/textInputs/TextInputWithLeftButton.svelte';
import Input_IconRight from '$lib/components/common/inputs/textInputs/TextInputWithRightIcon.svelte';
import Input_IconRightInteractive from '$lib/components/common/inputs/textInputs/TextInputWithRightButton.svelte';
import Input_InfoLeft from '$lib/components/common/inputs/textInputs/TextInputWithLeftText.svelte';
import Input_InfoRight from '$lib/components/common/inputs/textInputs/TextInputWithRightText.svelte';
import Input_LargeTextInput from '$lib/components/common/inputs/textInputs/LargeTextInput.svelte';
import Input_LinkInput from '$lib/components/common/inputs/textInputs/wrappers/LinkInput.svelte';

import Input_Main from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';
import Input_TextLeft from '$lib/components/common/inputs/textInputs/wrappers/TextInputWithLeftTextWrapper.svelte';
import Input_TextRight from '$lib/components/common/inputs/textInputs/wrappers/TextInputWithRightTextWrapper.svelte';
import Input_WithOption from '$lib/components/common/inputs/textInputs/TextInputWithOptionsIconRight.svelte';
import Input_WithOptionIconLeft from '$lib/components/common/inputs/textInputs/TextInputWithOptionsIconLeft.svelte';
import Input_SideOptions from '$lib/components/common/inputs/textInputs/TimeInput.svelte';

// Dropdowns
import Dropdown_Date from '$lib/components/common/dropdowns/Date.svelte';
import Dropdown_Default from '$lib/components/common/dropdowns/Default.svelte';
import Dropdown_MultiSelectDropdown from '$lib/components/common/dropdowns/MultiSelectDropdown.svelte';
import Dropdown_IconLeft from '$lib/components/common/dropdowns/IconLeft.svelte';
import Dropdown_InfoRight from '$lib/components/common/dropdowns/InfoRight.svelte';
import Dropdown_InfoRightWithParagraph from '$lib/components/common/dropdowns/InfoRightWithParagraph.svelte';
import Dropdown_DateRange from '$lib/components/common/dropdowns/DateRange.svelte';
import Dropdown_Search from '$lib/components/common/dropdowns/Search.svelte';
import Dropdown_SearchIconLeft from '$lib/components/common/dropdowns/TextInputWithSearchIconLeft.svelte';
import Dropdown_WithParagraph from '$lib/components/common/dropdowns/WithParagraph.svelte';
import Dropdown_WithIcon from '$lib/components/common/dropdowns/WithIcon.svelte';

export type _Details = SubcatInputConfigSections;

export type SubcatInputConfig = {
  component: DataFieldComponentType;
  props: {
    [key: string]: unknown;
  };
  options?: unknown[];
  isCustom?: boolean;
  isExtra?: boolean;
  show?: boolean;
};

export type SubcatInputConfigSections = {
  [key: string]: SubcatInputConfig[];
};

export type InputComponentType =
  | 'DefaultInput'
  | 'IconLeftInput'
  | 'IconRightInput'
  | 'IconLeftInteractiveInput'
  | 'IconRightInteractiveInput'
  | 'InfoRightInput'
  | 'InfoLeftInput'
  | 'TextLeftInput'
  | 'TextRightInput'
  | 'EditDefaultLabelInput'
  | 'EditLargeLabelInput'
  | 'LargeTextInput'
  | 'LinkInput'
  | 'SideOptions'
  | 'WithOptionInput'
  | 'WithOptionIconLeftInput';

export type DropdownComponentType =
  | 'DefaultDropdown'
  | 'MultiSelectDropdown'
  | 'IconLeftDropdown'
  | 'InfoRightDropdown'
  | 'InfoRightWithParagraphDropdown'
  | 'DateDropdown'
  | 'DateRangeDropdown'
  | 'SearchDropdown'
  | 'SearchIconLeftDropdown'
  | 'WithParagraphDropdown'
  | 'WithIconDropdown';

// type DropdownComponent = {
// 	component: DropdownComponentType;
// 	props: {
// 		[key: string]: any;
// 	};
// };

export type DataFieldComponentType = InputComponentType | DropdownComponentType;

export const inputMap = {
  DefaultInput: Input_Main,
  IconLeftInput: Input_IconLeft,
  IconRightInput: Input_IconRight,
  IconLeftInteractiveInput: Input_IconLeftInteractive,
  IconRightInteractiveInput: Input_IconRightInteractive,
  InfoLeftInput: Input_InfoLeft,
  InfoRightInput: Input_InfoRight,
  TextLeftInput: Input_TextLeft,
  TextRightInput: Input_TextRight,
  EditDefaultLabelInput: Input_EditDefaultLabel,
  EditLargeLabelInput: Input_EditLargeLabel,
  LargeTextInput: Input_LargeTextInput,
  LinkInput: Input_LinkInput,
  SideOptions: Input_SideOptions,
  WithOptionInput: Input_WithOption,
  WithOptionIconLeftInput: Input_WithOptionIconLeft
};

export const dropdownMap = {
  DefaultDropdown: Dropdown_Default,
  MultiSelectDropdown: Dropdown_MultiSelectDropdown,
  IconLeftDropdown: Dropdown_IconLeft,
  InfoRightDropdown: Dropdown_InfoRight,
  InfoRightWithParagraphDropdown: Dropdown_InfoRightWithParagraph,
  DateDropdown: Dropdown_Date,
  DateRangeDropdown: Dropdown_DateRange,
  SearchDropdown: Dropdown_Search,
  SearchIconLeftDropdown: Dropdown_SearchIconLeft,
  WithParagraphDropdown: Dropdown_WithParagraph,
  WithIconDropdown: Dropdown_WithIcon
};

// export type InputComponent = {
// 	component: InputComponentType;
// 	props: {
// 		[key: string]: any;
// 	};
// 	// isExtra: boolean;
// 	// isCustom: boolean;
// };

export const dataFieldMap = { ...inputMap, ...dropdownMap };
